import { useEffect, useState } from "react";
import "../styles/CountdownTimer.css";

const CountdownTimer = ({ targetDate }) => {
  const calculateTimeLeft = () => {
    const difference = new Date(targetDate) - new Date();

    if (difference <= 0) {
      return null;
    }

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      const updated = calculateTimeLeft();

      if (!updated) {
        setTimeLeft(null);
        clearInterval(timer);
      } else {
        setTimeLeft(updated);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  const display = timeLeft || {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  };

  return (
    <div className="modern-timer">
      <TimeBox value={display.days} label="Days" />
      <TimeBox value={display.hours} label="Hours" />
      <TimeBox value={display.minutes} label="Minutes" />
      <TimeBox value={display.seconds} label="Seconds" />
    </div>
  );
};

const TimeBox = ({ value, label }) => (
  <div className="time-box">
    <span className="time-value">
      {value.toString().padStart(2, "0")}
    </span>
    <span className="time-label">{label}</span>
  </div>
);

export default CountdownTimer;